module.exports = __webpack_public_path__ + "img/premiumtag.99c55d92.svg";